module.exports = __webpack_public_path__ + "img/sms-null.bd9f419b.svg";